import React, { useState } from 'react';
import PeticionFechaModal from './PeticionFechaModal';
import PeticionesAtendidasModal from './PeticionesAtendidasModal';

export default function SeguimientoEstudiantesModal({ open, student, onClose, onSuccess }) {
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [modalPeticionOpen, setModalPeticionOpen] = useState(false);
    const [modalPeticionesAtendidasOpen, setModalPeticionesAtendidasOpen] = useState(false);

    if (!open) return null;

    const handleViewPeticion = (curso) => {
        setSelectedCourse(curso);
        setModalPeticionOpen(true);
    };

    const handleClosePeticion = () => {
        setSelectedCourse(null);
        setModalPeticionOpen(false);
    };

    const handleViewAtendidas = (curso) => {
        setSelectedCourse(curso);
        setModalPeticionesAtendidasOpen(true);
    };

    const handleCloseAtendidas = () => {
        setSelectedCourse(null);
        setModalPeticionesAtendidasOpen(false);
    };

    const handleSuccessPeticion = (msg, variant, title) => {
        handleClosePeticion();
        // Recargar datos y disparar alerta si aplica
        if (onSuccess) onSuccess(msg, variant, title);
    };

    const handleSuccessAtendidaSilent = (msg, variant, title) => {
        // Al mostrarse la alerta, cerramos el modal anterior para evitar encimamiento
        handleCloseAtendidas();
        if (onSuccess) onSuccess(msg, variant, title);
    };

    return (
        <div style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
        }}>
            {/* Título */}
            <div style={{
                fontSize: '1.25rem',
                fontWeight: 600,
                color: '#1e293b',
                lineHeight: 1.3,
                borderBottom: '1px solid #e2e8f0',
                paddingBottom: '0.75rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <span>Cursos de <strong>{student.tituloEstudiante}</strong></span>
                <button
                    style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}
                    onClick={onClose}
                    title="Cerrar vista"
                >
                    &times;
                </button>
            </div>

            {/* Tabla de cursos */}
            <div style={{ overflowX: 'auto', flexGrow: 1 }}>
                <table className="roles-table" style={{ width: '100%' }}>
                    <thead style={{ background: '#f8fafc' }}>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '0.75rem' }}>Curso</th>
                            <th style={{ textAlign: 'center', padding: '0.75rem' }}>Estado</th>
                            <th style={{ textAlign: 'center', padding: '0.75rem' }}>Fecha Límite</th>
                            <th style={{ textAlign: 'center', padding: '0.75rem' }}>Petición de Extensión</th>
                        </tr>
                    </thead>
                    <tbody>
                        {student.cursos.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center', padding: '1rem', color: '#64748b' }}>
                                    Este estudiante no tiene cursos asignados.
                                </td>
                            </tr>
                        ) : (
                            student.cursos.map((c, i) => (
                                <tr key={`${c.idCurso}-${i}`}>
                                    <td style={{ padding: '0.75rem' }}><strong>{c.nombreCurso}</strong></td>
                                    <td style={{ textAlign: 'center', padding: '0.75rem' }}>
                                        <span style={{
                                            background: c.nombreEstado === 'aprobado' ? '#dcfce7' : c.nombreEstado === 'reprobado' ? '#fee2e2' : '#f1f5f9',
                                            color: c.nombreEstado === 'aprobado' ? '#166534' : c.nombreEstado === 'reprobado' ? '#991b1b' : '#334155',
                                            padding: '0.2rem 0.6rem',
                                            borderRadius: '12px',
                                            fontSize: '0.85rem',
                                            textTransform: 'capitalize'
                                        }}>
                                            {c.nombreEstado || 'En Curso'}
                                        </span>
                                    </td>
                                    <td style={{ textAlign: 'center', padding: '0.75rem' }}>
                                        {c.fechaTermino ? new Date(c.fechaTermino).toLocaleDateString() : '-'}
                                    </td>
                                    <td style={{ textAlign: 'center', padding: '0.75rem' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                            <button
                                                type="button"
                                                disabled={!c.tienePeticionFecha}
                                                className="btn-action"
                                                onClick={() => handleViewPeticion(c)}
                                                style={{
                                                    opacity: c.tienePeticionFecha ? 1 : 0.5,
                                                    cursor: c.tienePeticionFecha ? 'pointer' : 'not-allowed',
                                                    padding: '0.4rem 0.8rem',
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                Ver Petición
                                            </button>
                                            <button
                                                type="button"
                                                className="btn-action"
                                                onClick={() => handleViewAtendidas(c)}
                                                style={{
                                                    background: '#475569',
                                                    padding: '0.4rem 0.8rem',
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                Ver Atendidas
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Footer Buttons */}
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingTop: '0.75rem',
                borderTop: '1px solid #e2e8f0'
            }}>
                <button
                    type="button"
                    className="btn-action"
                    onClick={onClose}
                >
                    Cerrar
                </button>
            </div>

            {/* Modal flotante de petición */}
            <PeticionFechaModal
                open={modalPeticionOpen}
                cursoInfo={selectedCourse}
                onClose={handleClosePeticion}
                onSuccess={handleSuccessPeticion}
            />

            {/* Modal flotante de peticiones atendidas */}
            <PeticionesAtendidasModal
                open={modalPeticionesAtendidasOpen}
                cursoInfo={selectedCourse}
                onClose={handleCloseAtendidas}
                onSuccess={handleSuccessAtendidaSilent} // Silent refresh!
            />
        </div>
    );
}

